export default __webpack_public_path__ + "static/media/landing_page_feature4.661ae329.png";